// teamsApp.ts
import { app } from "@microsoft/teams-js";

// index.tsx already called app.initialize() — we just track readiness here
let resolveInit!: () => void;
let rejectInit!: (e: unknown) => void;

const initPromise = new Promise<void>((resolve, reject) => {
    resolveInit = resolve;
    rejectInit = reject;
});

// Called by index.tsx once initialize() resolves
export const markTeamsInitialized = () => resolveInit();
export const markTeamsInitFailed = (e: unknown) => rejectInit(e);

export const initializeTeamsApp = (): Promise<void> => initPromise;